export default "__VITE_ASSET__43d1408c__"